export enum DataSource {
  CAMS = 'CAMS',
  MEPS = 'MEPS',
  OEPS = 'OEPS',
}
